var cilTransfer = ["512 512", "<polygon fill='var(--ci-primary-color, currentColor)' points='356.687 228.687 379.313 251.313 494.627 136 379.313 20.687 356.687 43.313 433.372 120 16 120 16 152 433.372 152 356.687 228.687' class='ci-primary'/><polygon fill='var(--ci-primary-color, currentColor)' points='496 360 78.628 360 155.313 283.313 132.687 260.687 17.373 376 132.687 491.313 155.313 468.687 78.628 392 496 392 496 360' class='ci-primary'/>"];

export { cilTransfer };

